import { limitText } from 'src/utilities/limiteText';

// Interfaces para dados de select
export interface SelectOption {
  value: string | number;
  label: string;
}

// Regime Tributário
export const REGIME_TRIBUTARIO: SelectOption[] = [
  { value: '135', label: '135 - Lucro Real (padrão quando não informado)' },
  { value: '134', label: '134 - Lucro Presumido' },
  { value: '623', label: '623 - Simples Nacional' },
];

// Remetente
export const REMETENTE: SelectOption[] = [
  { value: '1', label: '1 - Indústria' },
  { value: '2', label: '2 - Atacadista' },
  { value: '3', label: '3 - Varejista' },
  { value: '23', label: '23 - Extrativista' },
  { value: '24', label: '24 - Importador' },
  { value: '178', label: '178 - Produtor rural' },
];

// Identificador da Operação (Tipo Nota)
export const TIPO_NOTA: SelectOption[] = [
  { value: '0', label: '0 - Saida' },
  { value: '1', label: '1 - Entrada' },
];

// Natureza da Operação
export const NATUREZA_OPERACAO: SelectOption[] = [
  { value: '94', label: '94 - Remessa de mercadoria recebida de terceiro em doação' },
  { value: '107', label: '107 - Saída em transferência de produção do estabelecimento' },
  { value: '108', label: '108 - Saída em transferência de mercadoria adquirida ou recebida de terceiros' },
  { value: '120', label: '120 - Venda de produção do estabelecimento' },
  { value: '121', label: '121 - Venda de mercadoria adquirida ou recebida de terceiros' },
  { value: '686', label: '686 - Remessa de produção em doação' },
];

// Finalidade
export const FINALIDADE: SelectOption[] = [
  { value: '43', label: '43 - Compra de material para uso ou consumo' },
  { value: '174', label: '174 - Recebimento em transferência para industrialização ou produção rural' },
  { value: '175', label: '175 - Recebimento em transferência para comercialização' },
  { value: '202', label: '202 - Compra para insumo' },
  { value: '220', label: '220 - Compra de bem para o ativo imobilizado' },
  { value: '354', label: '354 - Entrada de doação' },
  { value: '569', label: '569 - Compra para comercialização' },
];

// Destinatário
export const DESTINATARIO: SelectOption[] = [
  { value: '1', label: '1 - Indústria' },
  { value: '3', label: '3 - Consumidor final contribuinte' },
  { value: '6', label: '6 - Consumidor final não contribuinte' },
  { value: '138', label: '138 - Atacadista' },
  { value: '140', label: '140 - Varejista' },
  { value: '827', label: '827 - Outro estabelecimento da mesma empresa onde se tiver processado a industrialização' },
];

// Origem do Produto (usado apenas no tabUnique)
export const ORIGEM_PRODUTO: SelectOption[] = [
  { value: '0', label: '0 - Nacional' },
  { value: '1', label: '1 - Estrangeira - Importação direta' },
  { value: '2', label: '2 - Estrangeira - Adquirida no mercado interno' },
  { value: '3', label: '3 - Nacional - Mercadoria com mais de 40% de conteúdo de importação' },
  { value: '4', label: '4 - Nacional - Produzida em conformidade com processos produtivos básicos' },
  { value: '5', label: '5 - Nacional - Mercadoria com menos de 40% de conteúdo de importação' },
  { value: '6', label: '6 - Estrangeira - Importação direta sem similar nacional' },
  { value: '7', label: '7 - Estrangeira - Adquirida no mercado interno sem similar nacional' },
  { value: '8', label: '8 - Nacional - Mercadoria com produção em conformidade com processos produtivos básicos' },
];

// Funções auxiliares para buscar labels por value
export const getRegimeLabel = (value: string | number): string => {
  const option = REGIME_TRIBUTARIO.find((opt) => String(opt.value) === String(value));
  return option?.label || String(value);
};

export const getRemetenteLabel = (value: string | number): string => {
  const option = REMETENTE.find((opt) => String(opt.value) === String(value));
  return option?.label || String(value);
};

export const getTipoNotaLabel = (value: string | number): string => {
  const option = TIPO_NOTA.find((opt) => String(opt.value) === String(value));
  return option?.label || String(value);
};

export const getNaturezaLabel = (value: string | number): string => {
  const option = NATUREZA_OPERACAO.find((opt) => String(opt.value) === String(value));
  return limitText(option?.label,30) || String(value);
  // return option?.label || String(value);
};

export const getFinalidadeLabel = (value: string | number): string => {
  const option = FINALIDADE.find((opt) => String(opt.value) === String(value));
  return limitText(option?.label,20) || String(value);
  
};

export const getDestinatarioLabel = (value: string | number): string => {
  const option = DESTINATARIO.find((opt) => String(opt.value) === String(value));
  return option?.label || String(value);
};

export const getOrigemProdutoLabel = (value: string | number): string => {
  const option = ORIGEM_PRODUTO.find((opt) => String(opt.value) === String(value));
  return option?.label || String(value);
};

// Funções de formatação (para uso na tabela)
export const formatarData = (dataISO: string): string => {
  if (!dataISO) return '';
  const date = new Date(dataISO);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatarRegime = (regime: number): string => {
  const regimeLabel = getRegimeLabel(regime);
  return limitText(regimeLabel,30);
  // return getRegimeLabel(regime);
};

export const formatarRemetente = (remetente: number): string => {
  return getRemetenteLabel(remetente);
};

export const formatarTipoNota = (tipoNota: number): string => {
  return getTipoNotaLabel(tipoNota);
};

export const formatarNatureza = (natureza: number): string => {
  return getNaturezaLabel(natureza);
};

export const formatarFinalidade = (finalidade: number): string => {
  return getFinalidadeLabel(finalidade);
};

export const formatarDestinatario = (destinatario: number): string => {
  return getDestinatarioLabel(destinatario);
};

